import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Frontend from "./layouts/frontend";
import Home from "./pages/home";
import Gallery from "./pages/gallery";
import AboutHer from "./pages/about-her";
import AboutHim from "./pages/about-him";
import "./utils/styles/global.css";
import "antd/dist/antd.css";
import Story from "./pages/story";
import Location from "./pages/wedding-location";
import Accomodation from "./pages/accomodation";
import BrideMaids from "./pages/bride-maids";
import GroomsMen from "./pages/grooms-men";
import GiftRegistry from "./pages/gift-registry";
import RsvpPage from "./pages/rsvp-page";
import ScrollToTop from "./components/ScrollToTop";
import NotFoundPage from "./pages/404";
import CustomSwitch from "./layouts/customSwitch";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop>
          <Frontend>
            <CustomSwitch>
              <Route exact path="/" name="Home" component={Home} />
              <Route path="/about-her" name="About" component={AboutHer} />
              <Route path="/about-him" name="About" component={AboutHim} />
              <Route path="/gallery" name="Gallery" component={Gallery} />
              <Route path="/story" name="The Story" component={Story} />
              <Route path="/location" name="location" component={Location} />
              <Route
                path="/accomodation"
                name="accomodation"
                component={Accomodation}
              />
              <Route
                path="/bride-maids"
                name="brides maid"
                component={BrideMaids}
              />
              <Route
                path="/grooms-men"
                name="Grooms-men"
                component={GroomsMen}
              />
              <Route path="/gift-registry" component={GiftRegistry} />
              <Route path="/rsvp-page" component={RsvpPage} />
              <Route path="*" component={NotFoundPage} />
            </CustomSwitch>
          </Frontend>
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
